import { Paper, styled } from '@mui/material';
import { Form } from 'formik';

export const StyledAppointmentsSelectPartWrap = styled(Paper)(() => ({
	borderRadius: '16px',

	padding: '8px',
}));

export const StyledAppointmentsSelectPartForm = styled(Form)(() => ({
	display: 'flex',

	gap: '16px',
	flexDirection: 'column',
	alignItems: 'flex-start',
}));
